<template>
  <div class="cloud-intercom-page">
    <div class="ci-body">
      <h1 class="ci-body__title">
        {{ $t('Intercom.CloudIntercom.Common.Welcome') }}
      </h1>
      <p
        v-if="communityName"
        class="ci-body__subtitle"
      >
        {{ $t('Intercom.CloudIntercom.Common.CommunityIntercom', { name: communityName }) }}
      </p>
      <img
        class="ci-body__illustration"
        src="@/assets/img/intercom/cloud-intercom-welcome.webp"
        alt=""
      >
      <div class="ci-option-group">
        <button
          class="ci-option-card"
          @click="$emit('go-verification')"
        >
          <span class="ci-option-card__title">{{ $t('Intercom.CloudIntercom.HomePage.RegisteredVisitor') }}</span>
          <span class="ci-option-card__desc">{{ $t('Intercom.CloudIntercom.HomePage.RegisteredVisitorDesc') }}</span>
        </button>
        <button
          class="ci-option-card"
          @click="$emit('go-registration')"
        >
          <span class="ci-option-card__title">{{ $t('Intercom.CloudIntercom.HomePage.OnSiteVisitor') }}</span>
          <span class="ci-option-card__desc">{{ $t('Intercom.CloudIntercom.HomePage.OnSiteVisitorDesc') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  props: {
    communityName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-option-group {
  display: flex;
  gap: 16px;
  width: 100%;
}

.ci-option-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 42px 0px;
  border-radius: 6px;
  background-color: #f3f3f3;
  cursor: pointer;
  text-align: center;
  border: 0;

  &:active {
    background-color: #f5f5f5;
  }

  &__title {
    font-size: map-get($fontSize,large);
    font-weight: 600;
    color: #1f211f;
    margin-bottom: 6px;
  }

  &__desc {
    font-size: map-get($fontSize,x-small);
    color: #999;
  }
}
</style>
